import Button from '@/common/components/Button';
import Modal from '@/common/components/Modal';
import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { EquipmentData } from '../types/equipments.type';
import { useCardManuallyActivate } from '../hooks/useCardManuallyActivate';
import { ModalMessageSimple } from '@/common/components/ModalMessageSimple';

interface CardManuallyActivateModalProps {
  equipment?: EquipmentData
  showTrigger?: boolean
}

const CardManuallyActivateModal = ({ equipment, showTrigger }: CardManuallyActivateModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const [messages, setMessages] = useState<string[] | boolean>(false)

  const queryClient = useQueryClient();

  const {
    mutate: cardManuallyActivate,
    isPending: cardManuallyActivateIsPending,
    isError: cardManuallyActivateIsError
  } = useCardManuallyActivate({
    id: equipment?.card?.id,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['equipment', equipment?.id] })
      setIsOpen(false)
      setMessages(['Cartão ativado com sucesso!'])
    },
    onError: (error) => {
      if (error.response?.data.errors.base) {
        setMessages(error.response?.data.errors.base)
      }
    },
  });

  return (
    <>
      {showTrigger && (
        <Modal
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          Trigger={(
            <Button 
              disabled={cardManuallyActivateIsPending}
              operationKlassToCheckPermission="Client::Cards::ManuallyActivate"
            >
              Ativar cartão
            </Button>
          )}
          showClose={false}
          useCancellableFooter
          title="Tem certeza que deseja ativar este cartão?"
          subtitle="Essa ação não poderá ser desfeita."
          subtitleClassName="mt-1 text-md text-white-300"
          cancelButtonClassName="bg-white-100 rounded-es-lg"
          confirmButtonClassName="bg-blue-700 rounded-ee-lg"
          onConfirm={() => cardManuallyActivate()}
          disabled={cardManuallyActivateIsPending}
          confirmButtonIsLoading={cardManuallyActivateIsPending}
        />
      )}

      {messages && (
        <ModalMessageSimple
          messages={messages}
          setMessages={setMessages}
          isError={cardManuallyActivateIsError}
        />
      )}
    </>
  )
}

export default CardManuallyActivateModal;
